// @flow
let worker: ?Worker = null

export function terminate () {
  if (worker) {
    console.warn('Terminating Soil Jobs Worker')
    worker.terminate()
    worker = null
  }
}

export function initialize (): Worker {
  if (worker) {
    terminate()
  }

  console.warn('Initializing Soil Jobs Worker')

  // $FlowFixMe
  const SoilJobWorker = require('worker-loader?name=[hash].soil.jobs.wrkr.js!./worker.js')
  worker = new SoilJobWorker()
  return worker
}

export function getWorker (): Worker {
  if (worker) {
    return worker
  }

  return initialize()
}

export default {
  terminate,
  initialize,
  getWorker,
}
